import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { authAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Shield, Building2 } from 'lucide-react';
import { toast } from 'sonner';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.login({ username, password });
      login(res.data.token, res.data.user);
      toast.success('Welcome back!');
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-brand-panel">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
          </div>
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk' }}>Mega Millions</h1>
          <h2 className="text-xl font-medium opacity-90 mb-1">Reserve Escrow Bank</h2>
          <p className="text-sm opacity-70 mt-6 max-w-xs">Your trusted partner in wealth management and secure banking.</p>
          <div className="flex items-center gap-2 mt-10 text-sm opacity-80">
            <Shield className="h-4 w-4" />
            <span>256-bit SSL Encryption</span>
          </div>
        </div>
      </div>
      <div className="auth-form-panel">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>Welcome back</h2>
            <p className="text-sm text-gray-500 mt-1">Sign in to access your accounts</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && <div data-testid="auth-error-message" className="bg-red-50 text-red-600 text-sm px-4 py-3 rounded-xl border border-red-200">{error}</div>}
            <div className="space-y-2">
              <Label htmlFor="username">Username</Label>
              <Input data-testid="login-email-input" id="username" type="text" placeholder="Enter your username" value={username} onChange={(e) => setUsername(e.target.value)} className="h-11 rounded-xl" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input data-testid="login-password-input" id="password" type="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 rounded-xl" required />
            </div>
            <Button data-testid="login-submit-button" type="submit" className="w-full h-11 rounded-xl text-base" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
          <p className="text-center text-sm text-gray-500 mt-6">
            Don't have an account?{' '}
            <Link to="/register" className="text-[#0B5CAB] font-medium hover:underline">Create Account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
